import { getAudioNodeConnections } from './get-audio-node-connections';
export var getAudioNodeRenderer = function getAudioNodeRenderer(audioNode) {
  var audioNodeConnections = getAudioNodeConnections(audioNode);

  if (audioNodeConnections.renderer === null) {
    throw new Error('Missing the renderer of the given AudioNode in the audio graph.');
  }

  return audioNodeConnections.renderer;
};